import React, { useEffect, useState } from "react";
import Loader from "../../general/Loader";
import { toast } from "../../../utils/helpers";

const Form = ({motivo, setMotivo, cancel, onSave, saving, errors}) => {
    const [esValido, setEsValido] = useState(false);

    const onChangeProperty = (property, value) => {
        setMotivo({
            ...motivo,
            [property]: value
        });
    };

    useEffect(() => {
        if (!motivo.descripcion || !motivo.tipo) {
            setEsValido(false);
            return;
        }
        
        setEsValido(true);
    }, [motivo]);

    const onSummit = () => {
        if (esValido) onSave();
        else toast('Favor llenar todos los campos requeridos', 'error');
    };

    return <>
        <div className='popup__header'>{motivo.id ? "Editar" : "Crear"} Motivo de Visita</div>

        <div className='popup__body'>
            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>Tipo*:</label>
                </div>

                <div className="col col-md-7">
                    <select
                        name="tipo"
                        className="form-control"
                        placeholder="Seleccionar..."
                        onChange={e => onChangeProperty('tipo', e.target.value)}
                        value={motivo.tipo ?? ''}
                        disabled={saving}
                    >
                        <option value="">Seleccionar</option>
                        <option value="Médica">Médica</option>
                        <option value="Psicología">Psicología</option>
                    </select>
                    {errors.tipo && (
                        <small className='help-blockParams form-Text'>
                            {errors.tipo[0]}
                        </small>
                    )}
                </div>
            </div>

            <div className='row form-group'>
                <div className='col col-md-5'>
                    <label className='label form-control-label'>Descripción*:</label>
                </div>

                <div className='col col-md-7'>
                    <input
                        type="text"
                        id="descripcion"
                        name="descripcion"
                        className="form-control"
                        value={motivo.descripcion ?? ''}
                        onChange={(e) => onChangeProperty("descripcion", e.target.value)}
                        disabled={saving}
                    />
                    {errors.descripcion && (
                        <small className='help-blockParams form-Text'>
                            {errors.descripcion[0]}
                        </small>
                    )}
                </div>
            </div>
        </div>

        { saving
            ? <div className="row"><div className="mr-auto py-3"></div><Loader type="small" /><div className="py-3 mx-3"></div></div>
            : (<div className='popup__footer'>
                <div className="row">
                    <button
                        type='button'
                        onClick={cancel}
                        className='btn btn-plain ml-auto mr-2'>
                        Cancelar
                    </button>

                    <button type='button' onClick={onSummit} className='btn btn-outline-primary mr-2'>
                        Guardar
                    </button>
                </div>
            </div>)
        }
    </>;
};

export default Form;
